import axios from "axios";
import Config from "../Config";

export const getPaymentLinkAndQr = async (token, dueId, e) => {
  try {
    const res = await axios.get(
      `${Config.apiUrl}/due/qrcode?dueId=${dueId}&e=${e}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!res?.data?.isSuccess) {
      throw new Error(res?.data?.msg || "Unable to generate payment link");
    }

    return {
      success: true,
      paymentLink: res.data.link,
      qrCodeUrl: res.data.qrCode,
      reminderText: res.data.reminderText,
      //paymentId: res.data.paymentId,
      mobile: res.data.tenantMobile
    };

  } catch (err) {
    // Normalize error messages
    const message =
      err?.response?.data?.msg ||
      err?.response?.data?.message ||
      err?.message ||
      "Something went wrong";

    return {
      success: false,
      error: message,
    };
  }
};
